"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var React = require("react");
var store_1 = require("../data/store/store");
var owa_session_store_1 = require("owa-session-store");
var mobx_1 = require("mobx");
var getFilteredDateFormatOptions_1 = require("../utils/getFilteredDateFormatOptions");
var selectDateFormatOption_1 = require("../data/mutators/selectDateFormatOption");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var owa_datetime_format_1 = require("owa-datetime-format");
var EXAMPLE_DATE = new Date(2017, 8, 1);
var DateFormatSelection = /** @class */ (function (_super) {
    tslib_1.__extends(DateFormatSelection, _super);
    function DateFormatSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateFormatSelection.prototype.render = function () {
        var savedDateFormat = owa_session_store_1.getUserConfiguration().UserOptions.DateFormat;
        var selectedKey = store_1.default().selectedDateFormat || savedDateFormat;
        if (getFilteredDateFormatOptions_1.default().indexOf(selectedKey) === -1) {
            selectedKey =
                getFilteredDateFormatOptions_1.default().indexOf(savedDateFormat) === -1
                    ? getFilteredDateFormatOptions_1.default()[0]
                    : savedDateFormat;
        }
        return (React.createElement(Dropdown_1.Dropdown, { label: owa_options_strings_1.default.option_regional_dateFormat, options: this.dateFormatOptions, selectedKey: selectedKey, onChanged: this.onSelectDateFormat }));
    };
    DateFormatSelection.prototype.onSelectDateFormat = function (item) {
        selectDateFormatOption_1.default(item.key);
    };
    Object.defineProperty(DateFormatSelection.prototype, "dateFormatOptions", {
        get: function () {
            return getFilteredDateFormatOptions_1.default().map(function (shortDateFormat) {
                return {
                    text: owa_datetime_format_1.formatDate(EXAMPLE_DATE, shortDateFormat, false),
                    key: shortDateFormat,
                };
            });
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], DateFormatSelection.prototype, "dateFormatOptions", null);
    DateFormatSelection = tslib_1.__decorate([
        mobx_react_1.observer
    ], DateFormatSelection);
    return DateFormatSelection;
}(React.Component));
exports.default = DateFormatSelection;
//# sourceMappingURL=DateFormatSelection.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/view/DateFormatSelection.js
// module id = 4938
// module chunks = 2